import { Route, Routes } from 'react-router-dom';

import { NotFound } from '@/components/molecules/NotFound';

import CageWelfareDashboardContainer from './pages/CageWelfare/CageWelfareDashboard/CageWelfareDashboardContainer';
import CageWelfareFishSpeedProviderContainer from './pages/CageWelfare/CageWelfareFishspeed';
import CageWelfareMaturationContainer from './pages/CageWelfare/CageWelfareMaturation/CageWelfareMaturationContainer';
import CageWelfareMaturationDetectionsContainer from './pages/CageWelfare/CageWelfareMaturationDetections/CageWelfareMaturationDetectionsContainer';
import CageWelfareScalelossContainer from './pages/CageWelfare/CageWelfareScaleLoss/CageWelfareScalelossContainer';
import CageWelfareGraphsContainer from './pages/CageWelfare/CageWelfareWounds/pages/CageWelfareGraphs/CageWelfareGraphsContainer';
import CageWelfareWoundDetectionsContainer from './pages/CageWelfare/CageWelfareWounds/pages/CageWelfareWoundDetections';
import CageWelfareWoundsDashboardContainer from './pages/CageWelfare/CageWelfareWounds/pages/CageWelfareWoundsDashboard/CageWelfareWoundsDashboardContainer';
import { WelfareBioscopeGate } from './pages/CageWelfare/WelfareBioscopeGate';

interface WelfareRoutesProps {
    clientId: number;
    locationId: number;
    cageId: number;
}

/**
 * The legacy welfare pages under `/pen/:cageId/welfare`. Everything except fish speed sits behind
 * `WelfareBioscopeGate`, which sends colour-bioscope pens on to Health.
 */
export function WelfareRoutes(props: WelfareRoutesProps) {
    const { clientId, locationId, cageId } = props;
    const ids = { clientId, locationId, cageId };

    return (
        <Routes>
            <Route
                path="wounds/*"
                element={
                    <WelfareBioscopeGate>
                        <Routes>
                            <Route
                                path="detections"
                                element={<CageWelfareWoundDetectionsContainer {...ids} />}
                            />
                            <Route
                                path="graphs"
                                element={<CageWelfareGraphsContainer {...ids} />}
                            />
                            <Route
                                index
                                element={<CageWelfareWoundsDashboardContainer {...ids} />}
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </WelfareBioscopeGate>
                }
            />
            <Route
                path="maturation/detections"
                element={
                    <WelfareBioscopeGate>
                        <CageWelfareMaturationDetectionsContainer {...ids} />
                    </WelfareBioscopeGate>
                }
            />
            <Route
                path="scaleloss"
                element={
                    <WelfareBioscopeGate>
                        <CageWelfareScalelossContainer {...ids} />
                    </WelfareBioscopeGate>
                }
            />
            <Route
                path="maturation"
                element={
                    <WelfareBioscopeGate>
                        <CageWelfareMaturationContainer {...ids} />
                    </WelfareBioscopeGate>
                }
            />
            <Route path="speed" element={<CageWelfareFishSpeedProviderContainer />} />
            <Route
                index
                element={
                    <WelfareBioscopeGate>
                        <CageWelfareDashboardContainer {...ids} />
                    </WelfareBioscopeGate>
                }
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
